import { render, staticRenderFns } from "./CenterPage.vue?vue&type=template&id=0f6a04ab&scoped=true"
import script from "./CenterPage.vue?vue&type=script&lang=js"
export * from "./CenterPage.vue?vue&type=script&lang=js"
import style0 from "./CenterPage.vue?vue&type=style&index=0&id=0f6a04ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a04ab",
  null
  
)

export default component.exports